/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type CustomIntlService from 'embercom/services/intl';

type Signature = {
  Args: {
    authenticatedAdmin: boolean;
  };
};

export default class Header extends Component<Signature> {
  @service declare intl: CustomIntlService;

  get isLoggedIn() {
    return this.args.authenticatedAdmin;
  }

  get buttonText() {
    return this.isLoggedIn
      ? this.intl.t('sign_up.new.sign_out')
      : this.intl.t('sign_up.new.sign_in');
  }

  get buttonLink() {
    return this.isLoggedIn ? 'admins/sign_out' : 'admins/sign_in';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Header': typeof Header;
    'signup/header': typeof Header;
  }
}
